import { deflate } from 'pako';

export const compress = async (data: object): Promise<string> => {
  const compressed = deflate(JSON.stringify(data), { level: 9 });
  return Buffer.from(compressed).toString('base64');
};
